<template>
  <div ref="uploader" class="uploader">
    <p v-if="courseName" :title="courseName" class="course-title">课程名称： <span>{{ courseName }}</span></p>
    <el-upload
      action=""
      class="uploader-com"
      :show-file-list="false"
      :on-change="uploadImgChange"
      :auto-upload="false"
      accept="image/png, image/jpg, image/jpeg"
      :disabled="disabled"
    >
      <img v-if="imgsrc" :src="imgsrc" class="imgel">
      <i v-else class="el-icon-plus uploader-icon" />
    </el-upload>
    <p class="uploader-title" :title="imgInfo.name">
      <span v-if="required" class="required-point">*</span> <span>{{ imgInfo.name }}</span>
    </p>
    <template>
      <p class="uploader-desc" :style="{'display':!isLine ? 'block' : 'inline-block'}">支持上传*.png、*.jpg <span>&nbsp;</span></p>
      <p class="uploader-desc" :style="{'display':!isLine ? 'block' : 'inline-block'}">大小不超过{{ imgInfo.size }}M <span>&nbsp;</span></p>
      <p class="uploader-desc" :style="{'display':!isLine ? 'block' : 'inline-block'}">尺寸：{{ imgInfo.width }}*{{ imgInfo.height }}px</p>
      <div v-if="courseName" class="del-box">
        <img src="@/assets/images/transh-del.svg" class="cursor-pointer" alt="" @click="deleteCourse">
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'UpdateImage',
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    imgInfo: {
      type: Object,
      default: () => ({ name: '', size: 5, width: 1125, height: 1125 }),
    },
    customStyle: {
      type: Object,
      default: () => ({ width: '150px', height: '150px' }),
    },
    courseName: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    isLine: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgsrc: this.imageUrl,
    };
  },
  mounted() {
    this.$refs.uploader.style.setProperty('--uploader-width', this.customStyle.width);
    this.$refs.uploader.style.setProperty('--uploader-height', this.customStyle.height);
    this.$refs.uploader.style.setProperty('--uploader-line-height', this.customStyle.height);
    if (this.imageUrl) {
      this.imgsrc = this.imageUrl;
    }
  },
  updated() {
    if (this.imageUrl) {
      this.imgsrc = this.imageUrl;
    }
    console.log('this.disabled', this.disabled);
  },
  methods: {
    uploadImgChange(e) {
      this.checkImg(e);
    },
    checkImg(e) {
      const file = e.raw;
      const imgTypeList = ['image/png', 'image/jpg', 'image/jpeg'];
      if (!imgTypeList.includes(file.type)) {
        this.$message.error('请上传png、jpg、jpeg格式的图片');
        return;
      }
      if (file.size > this.imgInfo.size * 1024 * 1024) {
        this.$message.error(`请上传不超过${this.imgInfo.size}M的图片`);
        return;
      }
      // 尺寸
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (img.width !== this.imgInfo.width || img.height !== this.imgInfo.height) {
          this.$message.error(`请上传${this.imgInfo.width}px*${this.imgInfo.height}px的图片`);
          return;
        }
        this.$Api.uploadFile.uploadImage(file, 'trainingPlan/').then(data => {
          this.uploadLoading = false;
          this.imgsrc = data;
          if (this.item.taskId) {
            this.$emit('uploadImgChange', { url: data, item: this.item });
          } else {
            this.$emit('upload', { url: data, key: this.imgInfo.key });
          }
        });
        this.$message.success('图片上传成功');
      };
    },
    deleteCourse() {
      if (this.disabled) return;
      this.$emit('deleteCourse', this.item);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .uploader-com .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .uploader-com.el-upload:hover {
  border-color: #409EFF;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: var(--uploader-width);
  height: var(--uploader-height);
  line-height: var(--uploader-line-height);
  text-align: center;
  background-color: #f7f7f7;
}
.imgel {
  width: var(--uploader-width);
  height: var(--uploader-height);
  display: block;
  object-fit: cover;
}
.uploader-title{
  max-width:186px;
  color: #494949;
  font-size: 14px;
  margin-top: -2px;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.required-point{
  color: #FF4D4F;
  margin-right: 2px;
}
.uploader-desc{
  line-height: 1.4;
  color: #bbb;
  font-size: 12px;
}
.course-title{
  max-width: 186px;
  color: #494949;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.2;
  // 超出部分省略号
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.del-box{
  display: flex;
  justify-content: flex-end;
}
.cursor-pointer{
  cursor: pointer;
}
</style>
